import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
// import FormSelect from '@/components/form-select/store'
// import FormSelect from '@/components/form-select/store'

Vue.component(FeatherIcon.name, FeatherIcon)
// Vue.component("form-select", FormSelect)
